module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_1@3x.11c81f70.png";